import { useTranslation } from "react-i18next";

import QuestionTypeIcon from "@/components/QuestionIcon";
import { FormControl } from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { QUESTION_TYPE } from "@/schemas/question";
import { forwardRef, memo } from "react";
import { ControllerRenderProps, useFormState } from "react-hook-form";
import useSurvey from "../hooks/useSurvey";

interface QuestionTypeSelectProps extends ControllerRenderProps {
  index: number;
}

export default memo(
  forwardRef<HTMLButtonElement, QuestionTypeSelectProps>(
    function QuestionTypeSelect({ index, onChange, value }, ref) {
      const { t } = useTranslation();
      const { switchQuestionType } = useSurvey();

      const { isSubmitting, disabled } = useFormState();

      const onValueChange = (value: string) => {
        switchQuestionType(index, value);
        onChange(value);
      };

      return (
        <Select
          onValueChange={onValueChange}
          defaultValue={value}
          disabled={isSubmitting || disabled}
        >
          <FormControl>
            <SelectTrigger ref={ref}>
              <SelectValue />
            </SelectTrigger>
          </FormControl>
          <SelectContent>
            {QUESTION_TYPE.map((type) => (
              <SelectItem value={type} key={type}>
                <div className="flex flex-row gap-2 truncate">
                  <QuestionTypeIcon className="shrink-0" type={type} />
                  {t(`questionTypes.${type}`)}
                </div>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      );
    },
  ),
);
